<template>
    <div class="mb-3">
        <p class="mb-2">
            <strong>{{ label }}</strong>
        </p>
        <p class="satisfaction-icons mb-0">
            <i
                @click="onClickSatisfaction('smile')"
                :class="[
                    'satisfaction-icon',
                    'fa',
                    'fa-smile-o',
                    'mr-2',
                    {
                        'satisfaction-icon-selected text-success':
                            satisfaction.smile,
                    },
                ]"
            ></i>
            <i
                @click="onClickSatisfaction('meh')"
                :class="[
                    'satisfaction-icon',
                    'fa',
                    'fa-meh-o',
                    'mr-2',
                    {
                        'satisfaction-icon-selected text-warning':
                            satisfaction.meh,
                    },
                ]"
            ></i>
            <i
                @click="onClickSatisfaction('frown')"
                :class="[
                    'satisfaction-icon',
                    'fa',
                    'fa-frown-o',
                    {
                        'satisfaction-icon-selected text-danger':
                            satisfaction.frown,
                    },
                ]"
            ></i>
        </p>
    </div>
</template>

<script>
const satisfactionInitialState = {
    smile: false,
    meh: false,
    frown: false,
}

const enumToSatisfaction = enumerable => ({
    smile: enumerable == 1,
    meh: enumerable == 2,
    frown: enumerable == 3,
})

const satisfactionToEnum = satisfaction =>
    satisfaction.smile
        ? 1
        : satisfaction.meh
        ? 2
        : satisfaction.frown
        ? 3
        : null

export default {
    name: 'CSatisfaction',
    props: ['value', 'label'],
    data() {
        return {
            satisfaction: { ...satisfactionInitialState },
        }
    },
    mounted() {
        this.satisfaction = enumToSatisfaction(this.value)
    },
    methods: {
        onClickSatisfaction(key) {
            const oldStatus = this.satisfaction[key]
            this.satisfaction = { ...satisfactionInitialState }
            this.satisfaction[key] = !oldStatus
            this.$emit('update:value', satisfactionToEnum(this.satisfaction))
        },
    },
    watch: {
        value(newValue) {
            this.satisfaction = enumToSatisfaction(newValue)
        },
    },
}
</script>

<style scoped>
.satisfaction-icons {
    font-size: 1.6rem;
}
.satisfaction-icon-selected,
.satisfaction-icons .satisfaction-icon:hover {
    cursor: pointer;
    font-size: 2rem;
}
</style>
